import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/**
 * OPENING A PAGE THAT IS NOT THIS APP — sign-in with a provider, a privacy policy, a
 * store listing.
 *
 * Never `window.location = url` inside the app: in a web view that REPLACES the app with a
 * page that has no way back, and the user's only exit is force-quitting. On device this
 * opens the system's own browser sheet, which returns control when it closes.
 */
export async function openExternal(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url, presentationStyle: "popover" });
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

/** Closes the sheet after a provider hands control back through a deep link. */
export async function closeExternal(): Promise<void> {
  if (Capacitor.isNativePlatform()) await Browser.close().catch(() => {});
}
